import { useQuery, gql, type QueryResult } from '@apollo/react-hooks';
import { getAssetPlan } from '#/graphql/queries';
import type { GetAssetPlanQuery } from '#/graphql/types';

export const GET_ASSET_PLAN = gql(getAssetPlan);

const useAssetPlanQuery = (id?: string) => {
  const query: QueryResult<GetAssetPlanQuery> = useQuery(GET_ASSET_PLAN, {
    variables: { id },
    fetchPolicy: 'cache-and-network',
    skip: !id,
  });

  return query;
};

export default useAssetPlanQuery;
